// @flow

function isDevMode() {
  return process.env.NODE_ENV === "development";
}

const useEmulators = false;

function isIos() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

function isPWA() {
  return (
    (window.navigator != null && window.navigator.standalone) ||
    window.matchMedia("(display-mode: standalone)").matches
  );
}



const dev = {
  isDevMode,
  isIos,
  isPWA,
  useEmulators
};

export default dev;
